import { useContext } from "react";

import { UserInfoContext } from "helpers/globalContext/UserInfoContext";

import type UserTabPermissions from "types/UserTabPermissions/UserTabPermissions";

// Generic type for permissions
export function usePermission<T extends keyof UserTabPermissions>(
    tab: T,
    permission: keyof UserTabPermissions[T] | (keyof UserTabPermissions[T])[],
) {
    const userContext = useContext(UserInfoContext);

    if (!userContext?.permissions) {
        return false;
    }

    const perms = userContext.permissions;

    if (Array.isArray(permission)) {
        return permission.every((perm) => perms.hasPermission(tab, perm));
    }

    return perms.hasPermission(tab, permission);
}
